import styled, { css } from 'styled-components';

export const ImgDescCardContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: ${(props) => props.$gap || '16px'};
  margin: 0 auto;
`;

/** Wrap image when blendImageBoundary is on: rounded outer edge + soft inward feather toward content */
export const JetImgShell = styled.div`
  flex: 0 0 ${(props) => (props.$hasRightSlot ? '33.3333%' : '50%')};
  order: ${(props) => (props.$isLeft ? 1 : 2)};
  align-self: stretch;
  display: flex;
  overflow: hidden;
  max-height: 700px;
  min-height: 280px;

  ${(props) =>
    props.$blend
      ? css`
          margin: 6px 0;
          border-radius: ${props.$isLeft
            ? 'clamp(10px, 1.8vw, 16px) 0 0 clamp(10px, 1.8vw, 16px)'
            : '0 clamp(10px, 1.8vw, 16px) clamp(10px, 1.8vw, 16px) 0'};
          box-shadow: ${props.$isLeft
            ? '12px 0 32px rgba(15, 23, 42, 0.1)'
            : '-10px 0 28px rgba(15, 23, 42, 0.07)'};
        `
      : ''}
`;

export const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;
  padding: var(--home-block-padding) 0;
  gap: 16px;
`;

export const JetImg = styled.img`
  display: block;
  object-fit: cover;
  object-position: center;
  transform: ${(props) => (props.$flip ? 'scaleX(-1)' : 'none')};

  ${(props) =>
    props.$blend
      ? css`
          width: 100%;
          height: 100%;
          min-height: 320px;
          flex: 1 1 auto;
          max-height: none;
          box-shadow: ${props.$isLeft
            ? 'inset -36px 0 56px -18px rgb(244 246 252 / 55%)'
            : 'inset 36px 0 56px -18px rgb(244 246 252 / 55%)'};
        `
      : css`
          width: auto;
          flex: 0 0 ${props.$hasRightSlot ? '33.3333%' : '50%'};
          max-height: 700px;
          order: ${props.$isLeft ? 1 : 2};
        `}
`;

export const DescBox = styled.div`
  width: 100%;
  flex: 0 0 ${(props) => (props.$hasRightSlot ? '33.3333%' : '50%')};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  background: #f4f6fc;
  padding: 24px;
  border-radius: 2px;
  order: ${(props) => (props.$isLeft ? 2 : 1)};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
`;

export const Title = styled.h2`
  font-weight: 600;
  font-size: 40px;
  margin: 0;
  line-height: normal;
`;

export const DescBoxContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
`;

export const Desc = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 1.3;
  color: #424748;
`;

export const RightSlot = styled.div`
  width: auto;
  flex: 0 0 33.3333%;
  order: 3;
`;
